import {InputAdornment, TextField} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import classNames from 'classnames';
import CloseIcon from "@mui/icons-material/Close";
import {useAppDispatch, useAppSelector} from "../../../hooks/ReduxHooks";
import {PreferenceActions} from "../../../redux/PreferencesSlice";
import {AppState} from "../../../AppState";

interface CommonSearchControlProps {
    promptText: string;
    searchTextSelector: (state: AppState) => string;
    onSearchTextChange: (text: string) => void;

    disabled?: boolean;
}

export const CommonSearchControl = ({
                                        promptText,
                                        searchTextSelector,
                                        onSearchTextChange,
                                        disabled,
                                    }: CommonSearchControlProps) => {

    const dispatch = useAppDispatch();

    const isMobile = useAppSelector(s => s.system.isMobile);
    const searchText = useAppSelector(searchTextSelector);

    function cancelSearch() {
        onSearchTextChange("");
        dispatch(PreferenceActions.changeShowingSearch(false));
    }

    return (
        <TextField
            className={classNames({"search-highlight": !!searchText})}
            fullWidth
            value={searchText}
            autoFocus
            disabled={disabled}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon/>
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        {(searchText || isMobile) && <CloseIcon className="selectable pointer" onClick={cancelSearch}/>}
                    </InputAdornment>
                )
            }}
            placeholder={promptText}
            onChange={e => onSearchTextChange(e.target.value)}/>
    );
};
